// @flow

import Dispatcher from 'dispatcher';
import * as NeighborhoodActionTypes from 'action_types/NeighborhoodActionTypes';
import Neighborhood from 'models/Neighborhood';
import NeighborhoodZip from 'models/NeighborhoodZip';
import ApiClient from 'utils/ApiClient';
class NeighborhoodActions {
  getNearNeighborhoods(location: {} = {}): Promise<any> {
    return ApiClient.get({
      path: '/neighborhoods/nearest_neighborhoods.json',
      data: location,
      success: response => {
        Dispatcher.dispatch({
          type: NeighborhoodActionTypes.GET_NEAREST_NEIGHBORHOODS,
          neighborhoods: response.neighborhoods.map(
            neighborhood => new Neighborhood(neighborhood)
          )
        });
      }
    });
  }

  getNeighborhoods(
    data: { zip_code: string },
    index?: number = ''
  ): Promise<any> {
    return ApiClient.get({
      path: '/neighborhoods.json',
      data,
      success: response => {
        Dispatcher.dispatch({
          type: NeighborhoodActionTypes.NEIGHBORHOODS_BY_ZIP,
          neighborhoods: response.neighborhoods.map(
            neighborhood => new NeighborhoodZip(neighborhood)
          ),
          index: index
        });
      }
    });
  }

  getNeighborhoodsWithoutFlux(zipCode: string) {
    return ApiClient.get({
      path: '/neighborhoods.json',
      data: { zip_code: zipCode }
    });
  }
}

export default new NeighborhoodActions();
